/**
 * THE PHONE'S NAVIGATION: five tabs along the bottom edge, and a sheet for the rest.
 *
 * The left rail is 232px wide and a phone is 393. Until Phase 18 the rail rendered anyway and the
 * game got what was left, which was nothing a player could use. On a phone the rail is gone and
 * this is what replaces it.
 *
 * Four routes get a tab of their own and the choice is the loop, not the route order: Home is
 * where the three numbers are read, Jobs and Crimes are where Energy goes, and The Street is where
 * Nerve goes. That is GAME-DESIGN 1.2's burst session. Everything else is one tap further, behind
 * More, in the order the rail lists it, with Sign out at the end because it is the one control
 * nobody should hit by accident.
 */

import { useState } from 'react'
import { JEST } from '../build'
import { Icon, type IconName } from '../ui/Icon'
import { SignOut } from './TopBar'
import { useSession } from '../game/session'
import { ROUTES, type Route } from './routes'

const PRIMARY: Route[] = ['home', 'jobs', 'crimes', 'fights']

export function BottomTabs({ route, go }: { route: Route; go: (r: Route) => void }) {
  const [more, setMore] = useState(false)
  const openNotify = useSession((s) => s.openNotify)
  const inMore = !PRIMARY.includes(route)
  const rest = ROUTES.filter((r) => !PRIMARY.includes(r.id))

  return (
    <>
      <nav className="tabbar" aria-label="Main">
        {PRIMARY.map((id) => {
          const r = ROUTES.find((x) => x.id === id)!
          const on = route === id
          return (
            <button key={id} onClick={() => go(id)} aria-current={on ? 'page' : undefined}>
              <Icon n={r.icon as IconName} s={20} c={on ? 'var(--gold)' : 'var(--ink-dim)'} />
              {r.label}
            </button>
          )
        })}
        <button
          onClick={() => setMore(true)}
          aria-current={inMore ? 'page' : undefined}
          aria-haspopup="dialog"
          aria-expanded={more}
        >
          <Icon n="chevd" s={20} c={inMore ? 'var(--gold)' : 'var(--ink-dim)'} />
          More
        </button>
      </nav>

      {more && (
        <div className="sheet" onClick={() => setMore(false)} role="presentation">
          <div role="dialog" aria-label="More" onClick={(e) => e.stopPropagation()}>
            <div
              className="t-label"
              style={{ padding: '14px 18px 8px', color: 'var(--brass-lit)', letterSpacing: '.3em' }}
            >
              Ashport
            </div>
            {rest.map((r) => {
              const on = route === r.id
              return (
                <button
                  key={r.id}
                  className="sheet-row"
                  aria-current={on ? 'page' : undefined}
                  onClick={() => {
                    setMore(false)
                    go(r.id)
                  }}
                >
                  <Icon n={r.icon as IconName} s={18} c={on ? 'var(--gold)' : 'var(--ink-dim)'} />
                  {r.label}
                </button>
              )
            })}
            {/* PHASE 23. The card lives behind More on a phone, above Sign out. */}
            <button
              className="sheet-row"
              onClick={() => {
                setMore(false)
                openNotify()
              }}
            >
              <Icon n="bell" s={18} c="var(--ink-dim)" />
              Notifications
            </button>
            {/* PHASE 26. Not under the Jest build: the platform owns the session (1ag.8). */}
            {!JEST && (
              <div style={{ padding: '10px 18px 14px' }}>
                <SignOut labelled />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
